import { useEffect, useState } from "react";
import CategoryController from "../controllers/CategoryController";
import { useModal } from "../_providers/ModalProvider";
import SingleInputModal from "../_modals/SingleInputModal";
import { usePlan } from "../_providers/PlanProvider";

const CategoryPage = () => {
    const [income, setIncome] = useState<string[]>([]);
    const [expense, setExpense] = useState<string[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string>("");

    const {setModal, closeModal} = useModal();

    const reloadCategories = async () => {
        Promise.all([
            CategoryController.getCategories("income"),
            CategoryController.getCategories("expense")
        ]).then(([incomeCategories, expenseCategories]) => {
            setIncome(incomeCategories.map((category) => category.uid));
            setExpense(expenseCategories.map((category) => category.uid));
            setLoading(false)
        }).catch((error) => {   
            setError(error.message); 
            setLoading(false)
        });
    }

    const createCategory = (type: "income" | "expense") => {
        const onCreate = (category: string) => {
            CategoryController.createCategory(category, type).then(() => {
                if(type === "income") {
                    setIncome((prev) => [...prev, category]);
                } else {
                    setExpense((prev) => [...prev, category]);
                }
                closeModal();
            }).catch((error) => {
                setError(error.message);
            });
        }
        setModal(type == "income" ? "Create Income Category" : "Create Expense Category", <SingleInputModal onCreate={onCreate}/>)
    }
    const deleteCategory = (category: string, type: "income" | "expense") => {
        CategoryController.deleteCategory(category).then(() => {
            if(type === "income") {
                setIncome((prev) => prev.filter((cat) => cat !== category));
            } else {
                setExpense((prev) => prev.filter((cat) => cat !== category));
            }
        }).catch((error) => {   
            setError(error.message); 
        });
    }

    useEffect(() => {
        reloadCategories();
    }, []);

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error}</div>;
    return (
        <div>
        <h1>Category Page</h1>
        <p>This is the category page.</p>
        <h2>Income Categories</h2>
        <button onClick={() => createCategory("income")}>Create</button>
        <ul>
            {income.map((category) => (
                <li key={category}>{category}<button onClick={() => deleteCategory(category, "income")}>Delete</button></li>
            ))}
        </ul>
        <h2>Expense Categories</h2>
        <button onClick={() => createCategory("expense")}>Create</button>
        <ul>
            {expense.map((category) => (
                <li key={category}>{category} <button onClick={() => deleteCategory(category, "expense")}>Delete</button></li>
            ))}
        </ul>
        </div>
    );
}
export default CategoryPage;